import { DEFAULT_COLLECTION_ID } from '@/constants/routes';

interface UrlAPIOptions {
  search?: string;
}

type ParsedURL<T> = Omit<URL, 'searchParams'> & { searchParams: T };

class UrlAPI {
  new(url: string = '', options: UrlAPIOptions = {}) {
    let newURL = url.trim();

    if (newURL === DEFAULT_COLLECTION_ID) {
      newURL = '';
    }

    if (!newURL.startsWith('/')) {
      newURL = `/${newURL}`;
    }

    if (!newURL.endsWith('/')) {
      newURL += '/';
    }

    return `${newURL}${options?.search ? `?${options.search}` : ''}`;
  }

  parseSearchQuery<T = Record<string, string>>(query: string = ''): T {
    if (!query) {
      return {} as T;
    }

    const params = new URLSearchParams(query);

    return Object.fromEntries(params.entries()) as T;
  }

  parseURL<T = Record<string, string>>(url: string): ParsedURL<T> {
    if (!url) {
      return {} as ParsedURL<T>;
    }

    const parsedUrl = new URL(url);
    const searchParams = Object.fromEntries(parsedUrl.searchParams.entries());

    return {
      ...parsedUrl,
      searchParams,
    } as ParsedURL<T>;
  }

  isPro(pathname: string = '') {
    return pathname.includes('pro');
  }
}

export const urlAPI = new UrlAPI();
